import { DropdownCountry1 } from '@/components/DropdownCountry'
import { MyDatePicker } from '@/components/MyDatePicker'
import { useCountry } from './store'
import DataTable from './DataTable'

const AppleRegression = () => {
  return (
    <>
      <Form />
      <DataTable />
    </>
  )
}

const Form = () => {
  const country = useCountry((state) => state.value)
  const updateCountry = useCountry((state) => state.update)
  return (
    <div className="flex items-center gap-4 flex-wrap sm:gap-2 sm:py-2 xs:py-1 xs:gap-1">
      <DropdownCountry1 value={country} update={updateCountry} />
      <MyDatePicker getMaxDate="complete" showMaxDate={true} />
    </div>
  )
}

export default AppleRegression
